export default {
  innerColor: Styles.color.grey.one,
  locationContainerBackground: Styles.color.cardBackground,
  styledLinkColor: Styles.color.grey.one,
  titleColor: '',
};
